import {environments} from '../configs';

const IS_SDK_MODE = environments.VITE_APP_IS_SDK;

const PATHS = {
  home: IS_SDK_MODE ? '/' : '/:token/',
  summary: 'summary',
  guestRegistration: 'guest/registration',
  whoIsRegistering: 'guest/who-is-registering',
  addPersonalDataForm: 'add/guest',
  documentMRZ: 'document-mrz',
  faq: 'faq',
  notFount: 'not-found',
  taxes: {
    main: 'taxes',
    exemptions: 'exemptions',
  },
  verification: {
    main: 'verification',
    documentSelection: 'document-selection',
    scanQRCode: 'scan-qr-code',
    verificationCompleted: 'verification-completed',
    uploadingType: 'uploading-type',
    selfieInstructions: 'selfie-instructions',
    front: 'front',
    back: 'back',
    selfie: 'selfie',
    contacts: 'contacts',
  },
  deposits: 'deposit',
  payments: {
    main: 'payments',
    form: 'form',
    ordersHistory: 'order-history',
  },
  checkout: {
    main: 'checkout',
    beforeYouLeave: 'before-you-leave',
    rateYourStay: 'rate-your-stay',
    thanks: 'thanks-for-your-stay',
  },
  recommendations: {
    main: 'recommendations',
    details: {
      main: ':id',
      bookExperience: 'book-experience',
      confirmEmail: 'confirm-email',
    },
  },
  remoteAccess: 'remote-access',
  remoteKeys: 'remote-keys',
  searchReservation: {
    main: 'search-reservation',
    bookingCode: 'booking-code',
    checkingDate: 'checking-date',
    newReservation: 'new-reservation',
  },
  guidebook: 'guidebook',
  auth: {
    root: 'auth',
    createAccount: 'create-account',
    login: 'login',
    welcome: 'welcome',
  },
  oauth: {
    root: 'oauth',
    google: 'oauth/google',
  },
  onboarding: {
    root: 'onboarding',
    reservationType: 'reservation-type',
    numberOfGuests: 'number-of-guest',
    confirmLeaderGuest: 'confirm-leader-guest',
    whoIsComing: 'who-is-coming',
  },
  esim: {
    manage: 'esim/manage',
    choosePlan: 'esim/choose-plan',
    my: 'esim/my',
  },
};

const verificationTypesRoutes = [
  PATHS.verification.main,
  `${PATHS.verification.main}/:id`,
];
const addPersonalDataFormRoute = [
  PATHS.addPersonalDataForm,
  `${PATHS.addPersonalDataForm}/:id`,
];

export {PATHS, addPersonalDataFormRoute, verificationTypesRoutes, IS_SDK_MODE};
